export default __webpack_public_path__ + "static/media/img8.d8799b8a.PNG";